/**
 * this helper is for setting correct classes for <h>-tags
 * the returned class is for (smaller) font sizes, depending on breakpoint, text.length and hX tag
 */

import DeviceHelper from 'mixins/DeviceHelper';

const HeadingSizeHelper = {
  mixins: [
    DeviceHelper,
  ],
  methods: {
    /**
     * pass in the text and the number of the heading tag
     * h1: headingTagNumber = 1
     * h2: headingTagNumber = 2
     * etc...
     *
     * @param {String} headingText
     * @param {Number} headingTagNumber
     * @return {String} classReturn
     */
    hsh_getHeadingClass(headingText, headingTagNumber) {
      // const headingTagNumberReturn = parseInt(headingTagNumber, 10);
      let classReturn = `h${headingTagNumber}`;

      if (headingText.length > 40) classReturn = `h${headingTagNumber}-len40`;
      if (headingText.length > 80) classReturn = `h${headingTagNumber}-len80`;
      if (headingText.length > 120) classReturn = `h${headingTagNumber}-len120`;

      return classReturn;
    },
  },
};

export default HeadingSizeHelper;
